import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/buying/override/Surcharges'

export default {
  async getAll(filter) {
    return await axios
      .get(`${endpoint}/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/buyingTariff/buyingTariffOverriddenSurchargeService.js